import styled from 'styled-components';
export const StyledAssignmentContainer = styled.div.withConfig({
  displayName: "Assignmentstyled__StyledAssignmentContainer",
  componentId: "sc-1qdesgs-0"
})(["flex:auto;background-color:", ";"], ({
  theme
}) => theme.colors.white);